import { Button } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Title from '../../components/Title/Title';
import Auxiliary from '../../util/Auxiliary';
import { ParamsContext } from '../Context/ParamsContext';
import axios from '../../util/Api';
import Table from '../../components/Table/Basic';
import Date from '../../components/Formatter/Date';
import DeleteButton from './DeleteButton';

const Index = () => {
  const [loading, setLoading] = useState(true);
  const [violations, setViolations] = useState([]);
  const [total, setTotal] = useState(null);

  const [projectOptions, setProjectOptions] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);

  const params = useContext(ParamsContext);

  useEffect(() => {
    fetchViolation();
  }, [params]);

  useEffect(() => {
    fetchProjectOptions(null);
    fetchVendorOptions();
  }, []);

  const fetchViolation = () => {
    setLoading(true);
    const url = `/violation/list`;
    axios.get(url, { params: params }).then(resp => {
      setViolations(resp.data.violation);
      setTotal(resp.data.total);
      setLoading(false);
    }).catch(err => {});
  }

  const fetchProjectOptions = (division) => {
    const url = `/master/projects`;
    axios.get(url, { params: division ? { division: division } : {} }).then(resp => {
      const options = resp.data.reduce((arr, item) => {
        return [...arr, { value: `${item.id}`, label: item.name }];
      }, [{ value: '', label: 'Semua' }]);
      setProjectOptions(options);
    }).catch(err => {});
  }

  const fetchVendorOptions = () => {
    const url = `/master/vendors`;
    axios.get(url).then(resp => {
      const options = resp.data.reduce((arr, item) => {
        return [...arr, { value: item.id, label: item.name }];
      }, [{ value: '', label: 'Semua' }]);
      setVendorOptions(options);
    }).catch(err => {});
  }

  const columns = [
    {
      title: 'Nama',
      key: 'name',
      filter: true,
      render: record => record.passport.name,
    },
    {
      title: "Perusahaan",
      key: "vendor",
      filter: true,
      filterOptions: vendorOptions,
      render: record => record.passport.vendor.name,
    },
    {
      title: "Proyek",
      key: 'project',
      filter: true,
      filterOptions: projectOptions,
      render: record => record.passport_project.project.name
    },
    {
      title: "Tanggal Kejadian",
      key: 'date',
      sorter: true,
      render: record => <Date value={record.date}/>
    },
    {
      title: "Berlaku Sampai",
      key: 'expiry_date',
      sorter: true,
      render: record => <Date value={record.expiry_date}/>
    },
    {
      title: "Jenis Pelanggaran",
      key: 'level',
      filter: true,
      filterOptions: [
        {value: '', label: 'Semua'},
        {value: '1', label: 'SP1'},
        {value: '2', label: 'SP2'},
        {value: '3', label: 'SP3'},
      ],
      sorter: true,
      render: record => record.level.label
    },
    {
      title: "Remark",
      key: 'remark',
      render: record => record.remark
    },
    {
      title: "Tanggal Lapor",
      key: 'created_at',
      sorter: true,
      render: record => <Date value={record.created_at}/>
    },
    {
      title: "",
      key: 'action',
      render: record => {
        return (
          <>
            <DeleteButton id={record.id}/>
          </>
        );
      }
    }
  ];

  return (
    <Auxiliary>
      <Title>Data Pelanggaran</Title>
      <Link to={`/violation/create`}><Button type="primary">Update Pelanggaran</Button></Link>
      <Table
        columns={columns}
        dataSource={violations}
        loading={loading}
        total={total}
        showSorterTooltip
        pathname="/violation"
        sticky
      />
    </Auxiliary>
  );
}

export default Index;